(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["component-color-selectors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('component-color-selectors')) {
    customElements.define('component-color-selectors', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.setAttribute('data-tabs-ready', '');
        this.querySelector('.component-colors__heading').hidden = false;
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('fieldset'));
        this.querySelector('[role="tablist"]').hidden = false;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index));
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.activate(next, true);
          });
        });
        this.addEventListener('invalid', (event) => {
          if (this.invalidPending) return;
          this.invalidPending = true;
          const index = this.panels.findIndex((panel) => !panel.querySelector('input:checked'));
          if (index >= 0) this.activate(index);
          queueMicrotask(() => { this.invalidPending = false; });
        }, true);
        this.addEventListener('change', (event) => {
          const input = event.target;
          if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
          const index = this.panels.indexOf(input.closest('fieldset'));
          if (index < 0) return;
          this.updateSummary(index);
          const next = this.panels.findIndex((panel) => !panel.querySelector('input:checked'));
          if (next >= 0 && next !== index) this.activate(next, true);
        });
        this.panels.forEach((_, index) => this.updateSummary(index));
        this.activate(0);
      }
      activate(index, focus = false) {
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        if (focus) this.tabs[index].focus({ preventScroll: true });
      }
      updateSummary(index) {
        const input = this.panels[index].querySelector('input:checked');
        if (!input) return;
        this.panels[index].querySelector('[data-selected-color]').textContent = input.value;
        this.tabs[index].querySelector('[data-tab-color]').textContent = input.value;
        const mini = this.tabs[index].querySelector('.component-colors__mini');
        mini.setAttribute('style', input.nextElementSibling.getAttribute('style') || '');
        mini.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["frame-image-upload"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('frame-image-upload')) {
    customElements.define('frame-image-upload', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.fileInput = this.querySelector('[data-frame-file]');
        this.urlInput = this.querySelector('[data-frame-url]');
        this.status = this.querySelector('[data-frame-status]');
        this.preview = this.querySelector('[data-frame-preview]');
        this.removeButton = this.querySelector('[data-frame-remove]');
        this.defaultInput = this.querySelector('[data-frame-default]');
        this.defaultInput.addEventListener('change', () => this.clear());
        this.fileInput.addEventListener('change', () => this.upload());
        const dropZone = this.querySelector('.frame-upload__file-label');
        dropZone.addEventListener('dragover', event => event.preventDefault());
        dropZone.addEventListener('drop', event => {
          event.preventDefault();
          if (event.dataTransfer.files.length) this.upload(event.dataTransfer.files[0]);
        });
        this.removeButton.addEventListener('click', () => this.clear());
        this.notify();
      }
      get selectionSummary() {
        return this.urlInput?.value ? this.dataset.ready : !this.querySelector('[data-frame-default]')?.checked ? this.dataset.customLabel : this.dataset.listingLabel;
      }
      notify(show = false) {
        this.dispatchEvent(new CustomEvent('frame-upload-change', { bubbles: true, detail: { show } }));
      }
      clear() {
        this.controller?.abort();
        this.sequence = (this.sequence || 0) + 1;
        this.pending = false;
        this.urlInput.value = '';
        this.urlInput.disabled = true;
        this.fileInput.value = '';
        this.fileInput.setCustomValidity('');
        this.preview.hidden = true;
        this.preview.removeAttribute('src');
        this.removeButton.hidden = true;
        this.status.textContent = '';
        this.notify();
      }
      reportValidity() {
        if (this.defaultInput.checked) return true;
        if (!this.pending && this.urlInput.value) return true;
        this.status.textContent = this.pending ? this.dataset.loading : this.dataset.error;
        this.fileInput.setCustomValidity(this.status.textContent);
        this.notify(true);
        this.fileInput.reportValidity();
        return false;
      }
      async upload(file = this.fileInput.files[0]) {
        this.clear();
        if (!file) return;
        this.defaultInput.checked = false;
        this.notify();
        const sequence = this.sequence;
        try {
          if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || !/\.(jpe?g|png|webp)$/i.test(file.name) || file.size === 0 || file.size > 5242880) throw new Error(this.dataset.invalid);
          const bytes = new Uint8Array(await file.slice(0, 12).arrayBuffer());
          const jpeg = bytes[0] === 255 && bytes[1] === 216 && bytes[2] === 255;
          const png = [137,80,78,71,13,10,26,10].every((byte, i) => bytes[i] === byte);
          const webp = String.fromCharCode(...bytes.slice(0,4)) === 'RIFF' && String.fromCharCode(...bytes.slice(8,12)) === 'WEBP';
          if (!(jpeg || png || webp)) throw new Error(this.dataset.invalid);
          if (sequence !== this.sequence) return;
          this.pending = true;
          this.status.textContent = this.dataset.loading;
          this.controller = new AbortController();
          const data = new FormData();
          data.append('file', file, 'frame-image.' + (jpeg ? 'jpg' : png ? 'png' : 'webp'));
          data.append('upload_preset', this.dataset.preset);
          const timeout = setTimeout(() => this.controller.abort(), 90000);
          let response;
          try { response = await fetch(`https://api.cloudinary.com/v1_1/${this.dataset.cloud}/image/upload`, { method: 'POST', body: data, signal: this.controller.signal }); }
          finally { clearTimeout(timeout); }
          const result = await response.json();
          if (sequence !== this.sequence) return;
          if (!response.ok || result.resource_type !== 'image' || result.format !== 'jpg') throw new Error(this.dataset.error);
          const url = new URL(result.secure_url);
          if (url.origin !== 'https://res.cloudinary.com' || !url.pathname.startsWith(`/${this.dataset.cloud}/image/upload/`) || !url.pathname.endsWith('.jpg')) throw new Error(this.dataset.error);
          url.pathname = url.pathname.replace('/image/upload/', '/image/upload/fl_force_strip/');
          this.urlInput.value = url.href;
          this.urlInput.disabled = false;
          this.preview.src = url.href;
          this.preview.hidden = false;
          this.removeButton.hidden = false;
          this.fileInput.setCustomValidity('');
          this.status.textContent = this.dataset.ready;
          this.notify();
        } catch (error) {
          if (sequence !== this.sequence) return;
          this.status.textContent = error.message === this.dataset.invalid ? this.dataset.invalid : this.dataset.error;
        } finally {
          if (sequence === this.sequence) this.pending = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
